import { VesselObject } from '../object'

export default function apply(modules, context) {
  const object = new VesselObject({ modules, context })
  return object.classes
}
